import { createContext, useContext, useMemo } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
export const LinkContext = /*#__PURE__*/createContext(undefined);
export const LinkProvider = ({
  use,
  disabled,
  iconStyleOverrides,
  children
}) => {
  const value = useMemo(() => ({
    use,
    disabled,
    iconStyleOverrides
  }), [use, disabled, iconStyleOverrides]);
  return /*#__PURE__*/_jsx(LinkContext.Provider, {
    value: value,
    children: children
  });
};
export const useLinkContext = () => {
  return useContext(LinkContext);
};